import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { FormEnums } from "models/enums";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { DimensionFormTypes } from "models/formTypes";
import { SplitPresetsAddFormViewProps } from "models/propTypes/dimensionPropTypes";
//#endregion
//#region components
import GenericForm from "../forms/genericForm";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const SplitPresetsAddForm: ForwardRefRenderFunction<FormHandles, SplitPresetsAddFormViewProps> = (props, ref) => {
  return (
    <div>
      <div>
        <label className={cssExports.textLable}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.ChooseNameLabel)}
        </label>
      </div>
      <GenericForm<DimensionFormTypes.SplitPresets>
        formRef={ref}
        {...props}
        fields={{
          subject: {
            label: TranslationKeys.Common.Name,
            type: FormEnums.FormFieldType.TEXT,
            maxLength: 128,
          },
        }}
        hideSuccess
      />
    </div>
  );
};

export default forwardRef(SplitPresetsAddForm);
